export class MetricTest {
    private readonly metricDiv: HTMLElement = document.getElementById('meters');
    private readonly feetDiv: HTMLElement = document.getElementById('feet');
    showImperialButton: HTMLElement = document.getElementById('showImperialButton');
    newNumberButton: HTMLElement = document.getElementById('newNumberButton');

    constructor(private readonly metricRange: Array<number>, private readonly metricMultiplier: number) {
    }


    generateRandomMeters(): number {
        const min = this.metricRange[0];
        const max = this.metricRange[this.metricRange.length - 1];
        const highlightedNumber = Math.random() * (max - min) + min;

        return +highlightedNumber.toFixed(2);
    };

    cmToInches(centimeters: number) {
        return Math.floor(centimeters * 12)
    };

    onShowImperial(e: number) {
        this.feetDiv.style.visibility = 'visible';
    };

    onRefresh(e?: any) {
        const meters: number = this.generateRandomMeters();

        const feet: number = +(meters / this.metricMultiplier).toFixed(2);

        const inches: number = this.cmToInches((feet % 1));

        this.feetDiv.style.visibility = 'hidden';

        this.metricDiv.innerHTML = `${meters} meters`;

        this.feetDiv.innerHTML = `${Math.floor(feet)}'${inches}"`;
    }
}